import * as React from "react";
import {
  styledContainer,
  logoLink,
  styledRow,
  textCol,
  customCol,
} from "./OurBrands.module.scss";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

export const StyledContainer: React.FC<any> = (props) => {
  return (
    <Container fluid className={`${props.className} ${styledContainer}`}>
      {props.children}
    </Container>
  );
};
export const StyledRow: React.FC<any> = (props) => {
  return <Row className={`logos ${styledRow}`}>{props.children}</Row>;
};
export const CustomCol: React.FC<any> = (props) => {
  return (
    <Col {...props} className={customCol}>
      {props.children}
    </Col>
  );
};
export const LogoLink: React.FC<any> = (props) => {
  return (
    <Button
      {...props}
      id={props.id}
      className={`text-center w-100 p-0 ${logoLink}`}
    >
      {props.children}
    </Button>
  );
};
export const TextCol: React.FC<any> = (props) => {
  return <Col className={textCol}>{props.children}</Col>;
};
